<mat-card style="padding: 0.5in;">
  <div class="row" style="margin-bottom: 20px;">
    <div class="col-sm-6" style="text-align: left;">
      <button mat-raised-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </div>
    <div class="col-sm-6" style="text-align: right;">
      <button mat-raised-button color="primary" (click)="printReport()">
        <mat-icon>print</mat-icon>
        Print Report
      </button>
    </div>
  </div>

  <mat-card-content>

    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="0.5cm">
      
      <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
        <div style="position: absolute; bottom: 10px; left: 0; right: 0; text-align: center; font-size: 10pt;">
          {{datePrinted}} Page {{pageNum}} of {{totalPages}}
        </div>
      </ng-template>

      <div id="applicationReportContent">
        <div class="row">
          <div class="col-sm-12" style="text-align:center">
            <span class="text-primary" style="font-size: 30px">ORELAP Application</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12" style="text-align:center">
            <span class="text-primary" style="font-size: 24px">Laboratory Demographics</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12" style="text-align:center">
            <span style="font-size: 24px">Application Type: {{appData.applicationType}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <span class="pull-left" style="font-size: larger">Date Submitted: {{appData.submitDate}}</span>
          </div>
          <div class="col-sm-6" style="text-align: right;">
            <span style="font-size: larger">Submitted By: {{appData.submitter}}</span>
          </div>
        </div>


        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>1. Laboratory Identification</strong></span>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-6">
                    ORELAP Laboratory Identification Number
                  </div>
                  <div class="col-sm-6">
                    {{appData.orelapId}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    EPA Laboratory Identification Number
                  </div>
                  <div class="col-sm-6">
                    {{appData.epaId}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    Laboratory Name
                  </div>
                  <div class="col-sm-6">
                    {{appData.laboratoryName}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    Tax Identification Number
                  </div>
                  <div class="col-sm-6">
                    {{appData.taxId}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    Primary Accrediting Authority
                  </div>
                  <div class="col-sm-6">
                    {{appData.accreditingAuthority}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>2. Laboratory Physical Address</strong></span>
              </div>
              <div class="panel-body">
                <span>{{appData.siteAddress }}</span><br />
                <span>{{appData.siteCity}}, {{appData.siteState}} {{appData.siteZip}}</span><br />
                <span>Front Door: {{appData.latitude}} {{appData.longitude}}</span><br />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>3. Laboratory Mailing Address</strong></span>
              </div>
              <div class="panel-body">
                <span>{{appData.mailAddress }}</span><br />
                <span>{{appData.mailCity}}, {{appData.mailState}} {{appData.mailZip}}</span><br />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>4. Laboratory Billing Address</strong></span>
              </div>
              <div class="panel-body">
                <span>{{appData.billingAddress }}</span><br />
                <span>{{appData.billingCity}}, {{appData.billingState}} {{appData.billingZip}}</span><br />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>5. Laboratory Ownership</strong></span>
              </div>
              <div class="panel-body">
                <span>{{appData.ownerName}}</span><br />
                <span>{{appData.ownerAddress}}</span><br />
                <span>{{appData.ownerCity}}, {{appData.ownerState}} {{appData.ownerZip}}</span><br />
                <span>{{appData.ownerPhone}}</span><br />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>6. Laboratory Personnel and Contacts</strong></span>
              </div>
              <div class="panel-body">
                <table class="table table-condensed" style="width: 100%;">
                  <colgroup>
                    <col style="width: 10%" />
                    <col style="width: 10%" />
                    <col style="width: 10%" />
                    <col style="width: 10%" />
                    <col style="width: 40%" />
                    <col style="width: 10%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Discipline</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <!-- <th>Fax</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let person of appData.applicationPersonnel">
                      <tr>
                        <td>{{person.title}}</td>
                        <td>{{person.discipline}}</td>
                        <td>{{person.firstName}}</td>
                        <td>{{person.lastName}}</td>
                        <td>{{person.email}}</td>
                        <td>{{person.phone}}</td>
                        <!-- <td>{{person.fax}}</td> -->
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>7. Laboratory Hours of Operation</strong></span>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12">
                    {{appData.weekdays}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <table class="table" style="width: 100%">
                      <colgroup>
                        <col style="width: 25%" />
                        <col style="width: 15%" />
                        <col style="width: 60%" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th style="text-align: left;">Open</th>
                          <th style="text-align: left;">Close</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let hour of appData.applicationHours">
                          <tr>
                            <td>{{hour.day}}</td>
                            <td>{{hour.startHours}}</td>
                            <td>{{hour.endHours}}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-1">
                    Comments
                  </div>
                  <div class="col-sm-11">
                    {{appData.hoursComments}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>8. Laboratory Description</strong></span>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-2">
                    Laboratory Description
                  </div>
                  <div class="col-sm-10">
                    {{appData.labTypeDescription}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-2">
                    Other (Describe)
                  </div>
                  <div class="col-sm-10">
                    {{appData.labTypeOther}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-2">
                    Accept Commercial Samples?
                  </div>
                  <div class="col-sm-10">
                    {{appData.commercialSamples}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-2">
                    Commercial Samples Comments
                  </div>
                  <div class="col-sm-10">
                    {{appData.commercialSamplesComments}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="panel panel-default panel-borderless">
              <div class="panel-heading">
                <span style="font-size:x-large"><strong>9. Driving Directions - Primary Accreditation
                    Only</strong></span>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12">
                    {{appData.drivingDirections}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12" style="text-align:center">
            <span class="text-primary" style="font-size: 24px;color: #62b5d6;">Method Selection</span>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <ng-container *ngFor="let matrix of groupedAnalytes">

              <div class="row">
                <div class="col-sm-12">
                  <span class="matrix-label" style="font-size:x-large"><strong>{{matrix.matrix}}</strong></span>
                </div>
              </div>
              <ng-container *ngFor="let tech of matrix.tech ">
                <div class="row">
                  <div class="col-sm-12" style="background-color:#f5f5f5">
                    <span class="tech-label"><strong>{{tech.technology}}</strong></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <table class="table" style="width: 100%;padding-right: 10px;">
                      <colgroup>
                        <col style="width: 12%" />
                        <col style="width: 8%" />
                        <col style="width: 26%" />
                        <col style="width: 8%" />
                        <col style="width: 8%" />
                        <col style="width: 8%" />
                        <col style="width: 8%" />
                        <col style="width: 12%" />
                      </colgroup>
                      <thead class="backgroundPadding">
                        <tr>
                          <th class="col-sm-2 bg-info border-row">Method Reference</th>
                          <th class="col-sm-1 bg-info border-row">Version</th>
                          <th class="col-sm-4 bg-info border-row">Method Title</th>
                          <th class="col-sm-5 bg-info border-row" colspan="5"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let method of tech.methods">
                          <tr>
                            <td class="border-row">{{method.method}}</td>
                            <td class="border-row">{{method.analytes[0].revision}}</td>
                            <td class="border-row">{{method.analytes[0].title}}</td>
                            <td class="border-row" colspan="5"></td>
                          </tr>
                          <tr>
                            <td class="border-row" style="border-top: none" colspan="2"></td>
                            <td class="border-row"><strong>Analyte</strong></td>
                            <td class="border-row" style="padding-left: 10px; padding-right: 10px;">
                              <strong>Air</strong>
                            </td>
                            <td class="border-row" style="padding-left: 10px; padding-right: 10px;">
                              <strong>Potable
                                Water</strong></td>
                            <td class="border-row" style="padding-left: 10px; padding-right: 10px;">
                              <strong>Non-Potable</strong>
                            </td>
                            <td class="border-row" style="padding-left: 10px; padding-right: 10px;">
                              <strong>Solids</strong>
                            </td>
                            <td class="border-row" style="padding-left: 10px; padding-right: 10px;">
                              <strong>Biological
                                Tissue</strong></td>
                          </tr>
                          <ng-container *ngFor="let analyte of method.analytes ">
                            <tr>
                              <td class="border-row" style="border-top: none" colspan="2"></td>
                              <td class="border-row">{{analyte.analyte}}</td>
                              <td class="border-row"
                                style="text-align: center; padding-left: 10px; padding-right: 10px;">{{analyte.air}}
                              </td>
                              <td class="border-row"
                                style="text-align: center; padding-left: 10px; padding-right: 10px;">
                                {{analyte.drinkingWater}}</td>
                              <td class="border-row"
                                style="text-align: center; padding-left: 10px; padding-right: 10px;">
                                {{analyte.nonPotable}}</td>
                              <td class="border-row"
                                style="text-align: center; padding-left: 10px; padding-right: 10px;">
                                {{analyte.solids}}</td>
                              <td class="border-row"
                                style="text-align: center; padding-left: 10px; padding-right: 10px;">
                                {{analyte.biological}}</td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </kendo-pdf-export>
  </mat-card-content>
</mat-card>
